import React from "react"
import {
  Paper,
  Modal as ReactModal,
  Divider,
  Button,
  makeStyles,
  Grid,
  CircularProgress,
  Theme,
} from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { useGlobalStyles } from "../styles/globalStyles"

import { isMobile } from "react-device-detect"
const useStyles = makeStyles((theme: Theme) => ({
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    padding: theme.spacing(2),
  },
  modalBody: {},
  circularProgressWrapper: {
    position: "absolute",
    background: "#fff",
    top: 0,
    left: 0,
    alignItems: "center",
    height: "100%",
    width: "100%",
    borderRadius: "8px",
  },
  circularProgress: {
    margin: "auto",
    display: "block",
    marginTop: "50%",
  },
  modelMobile: {
    padding: "20px!important",
  },
}))

const Modal: React.FC<any> = (props: any) => {
  const {
    onClose,
    title,
    loading,
    fullWidth,
    disableBackdropClose = false,
    ...others
  } = props
  const classes = useStyles()
  const globalStyles = useGlobalStyles()
  return (
    <ReactModal {...others} onClose={disableBackdropClose ? null : onClose}>
      <Paper
        className={`${globalStyles.paper} ${globalStyles.modal} ${
          isMobile ? classes.modelMobile : ""
        } ${fullWidth === true ? globalStyles.modalFull : ""}`}
        elevation={3}
      >
        <div className={`${globalStyles.relative} ${classes.modalHeader}`}>
          <strong>{title}</strong>
          <Button className={globalStyles.modalCloseButton} onClick={onClose}>
            <CloseIcon />
          </Button>
        </div>
        <Divider />
        <div className={classes.modalBody}>{props.children}</div>
        {loading ? (
          <div className={classes.circularProgressWrapper}>
            <CircularProgress className={classes.circularProgress} />
          </div>
        ) : (
          ""
        )}
      </Paper>
    </ReactModal>
  )
}

export default Modal
